import $ from 'jquery';
import lozad from 'lozad';

$( function() {
  if ( $( '#gallery-grid' ).length ) {

    let itemsPerPage = 24;
    let currentPage = 1;

    let currentFilter = {
      features: [],
      finishes: [],
      styles: []
    };

    // render gallery
    const renderGallery = ( page, filter ) => {
      let start = ( page - 1 ) * itemsPerPage;
      let end = start + itemsPerPage;

      let isFiltered = Object.values(currentFilter).some(arr => arr.length > 0);

      let filteredGallery = galleryData.filter(image => {
        if (!isFiltered) return true;

        for (let key of ['features', 'finishes', 'styles']) {
          const selected = currentFilter[key];
          if (selected.length > 0) {
            const imageValues = image[key] || [];

            // AND logic: image must include ALL selected values
            const allMatch = selected.every(val => imageValues.includes(val));
            if (!allMatch) return false;
          }
        }

        return true;
      });


      let pagedGallery = filteredGallery.slice( start, end );

      $( '#gallery-grid' ).empty();

      pagedGallery.forEach((image, index) => {
        let imageContainer = `
          <div class="image-container animated" data-image-id="${image.id}" style="animation-delay: ${index * 95}ms;">
            <img class="lozad zoomable" data-src="${image.url}" alt="${image.alt}" data-caption="${image.caption}" data-key="${image.key}">
          </div>
        `;
        $('#gallery-grid').append(imageContainer);
      });
      
      renderPagination( filteredGallery.length, page );
      lozad().observe(); // init lazyload on render
      updateFilterAvailability();

    };

    const updateFilterAvailability = () => {
      ['features', 'finishes', 'styles'].forEach(group => {
        $(`#filter-tags .js-tag[data-type="${group}"]`).each(function () {
          const $option = $(this);
          const value = $option.data('view');
          const $checkbox = $option.find('.filter-checkbox');

          if (currentFilter[group].includes(value)) {
            $option.removeClass('disabled');
            $checkbox.prop('disabled', false);
            return;
          }

          const testFilter = structuredClone(currentFilter);
          testFilter[group] = [...testFilter[group], value];

          const matches = galleryData.filter(image => {
            for (let key of ['features', 'finishes', 'styles']) {
              const selected = testFilter[key];
              if (selected.length > 0) {
                const imageValues = image[key] || [];
                const allMatch = selected.every(val => imageValues.includes(val));
                if (!allMatch) return false;
              }
            }
            return true;
          });

          const isDisabled = matches.length === 0;
          $option.toggleClass('disabled', isDisabled);
          $checkbox.prop('disabled', isDisabled);
        });
      });
    };


      // render pagination
    const renderPagination = (totalItems, page) => {
      let totalPages = Math.ceil(totalItems / itemsPerPage);
      const pagination = $('#pagination-list');
      pagination.empty();

      if (totalPages <= 1) return;

      const appendEllipsis = () => {
        pagination.append('<li class="pagination-item ellipsis">...</li>');
      };

      if (page > 1) {
        $('#pagination-list').append(`<li class="pagination-item"><a href="#" data-page="${page - 1}"><</a></li>`);
      }

      $('#pagination-list').append(`<li class="pagination-item ${page === 1 ? 'active' : ''}"><a href="#" data-page="1">1</a></li>`);

      if (page > 2) {
        let start = Math.max(2, page - 1);
        let end = Math.min(totalPages - 1, page + 1);

        if (start > 2) appendEllipsis();

        for (let i = start; i <= end; i++) {
          $('#pagination-list').append(`<li class="pagination-item ${i === page ? 'active' : ''}"><a href="#" data-page="${i}">${i}</a></li>`);
        }

        if (end < totalPages - 1) appendEllipsis();
      } else {
        for (let i = 2; i <= Math.min(4, totalPages - 1); i++) {
          $('#pagination-list').append(`<li class="pagination-item ${i === page ? 'active' : ''}"><a href="#" data-page="${i}">${i}</a></li>`);
        }

        if (totalPages > 4) appendEllipsis();
      }

      if (totalPages > 1) {
        $('#pagination-list').append(`<li class="pagination-item ${page === totalPages ? 'active' : ''}"><a href="#" data-page="${totalPages}">${totalPages}</a></li>`);
      }

      if (page < totalPages) {
        $('#pagination-list').append(`<li class="pagination-item"><a href="#" data-page="${page + 1}">></a></li>`);
      }
    };


    $('#filter-tags').on('change', '.filter-checkbox', function() {
      const $option = $(this).closest('.js-tag');
      const type = $option.data('type');
      const value = $option.data('view');
      const isChecked = $(this).is(':checked');

      if (isChecked) {
        if (!currentFilter[type].includes(value)) {
          currentFilter[type].push(value);
        }
      } else {
        currentFilter[type] = currentFilter[type].filter(v => v !== value);
      }

      currentPage = 1;
      renderGallery(currentPage, currentFilter);
    });

    $('#clear-filters').on('click', function() {
      currentFilter = {
        features: [],
        finishes: [],
        styles: []
      };
      currentPage = 1;

      $('#filter-tags .filter-checkbox').prop('checked', false);

      renderGallery(currentPage, currentFilter);
    });

    // pagination click event
    $( '#pagination-list' ).on( 'click', '.pagination-item a', function( e ) {
      e.preventDefault();

      currentPage = parseInt( $( this ).data( 'page' ) );

      renderGallery( currentPage, currentFilter );

      // scroll to top of gallery
      $( 'html, body' ).animate( {
        scrollTop: $( '#main-content' ).offset().top
      }, 150 );
    });

    // close slider function
    const closeSlider = () => {
      $( 'body' ).removeClass( 'no-scroll' );
      $( '.overlay' ).fadeOut( function() {
        $( this ).remove();
      });
      $('.image-caption, .close-slider').remove();
      $( '.custom-slider' ).fadeOut();
    };

    // image click event to initialize slider
    $( '#gallery-grid' ).on( 'click', '.image-container', function( e ) {
      e.stopPropagation(); // prevent event bubbling
      
      $( 'body' ).toggleClass( 'no-scroll' );
      $( '<div class="overlay"></div>' ).appendTo( 'body' ).fadeIn();
      $( '<div class="close-slider">&times;</div>' ).appendTo( 'body' ).fadeIn();

      initializeSlider( $( this ).index() );
    });

    // overlay and close button click event to close slider
    $( 'body' ).on( 'click', '.overlay, .close-slider, .slider-inner', function() {
      closeSlider();
    });

    // init slider
    const initializeSlider = ( startIndex ) => {
      let currentIndex = startIndex;
      $( '#slider-inner' ).empty();

      // Add images to the slider
      $( '#gallery-grid .image-container' ).each( function() {
        let img = $( this ).find( 'img' );
        let slide = `
          <div class="slider-slide">
            <img src="${ img.data( 'src' ) }" alt="${ img.attr( 'alt' ) }">
            <div class="slider-caption">${ img.data( 'key' ) } ${ img.data( 'caption' ) }</div>
          </div>
        `;
        $( '#slider-inner' ).append( slide );
      });

      // Show the slider
      $( '.custom-slider' ).fadeIn();

      // Show the current slide
      showSlide( currentIndex );

      // Handle next and previous buttons
      $( '.slider-button-next' ).off( 'click' ).on( 'click', function() {
        currentIndex = ( currentIndex + 1 ) % $( '#slider-inner .slider-slide' ).length;
        showSlide( currentIndex );
      });

      $( '.slider-button-prev' ).off( 'click' ).on( 'click', function() {
        currentIndex = ( currentIndex - 1 + $( '#slider-inner .slider-slide' ).length ) % $( '#slider-inner .slider-slide' ).length;
        showSlide( currentIndex );
      });
    };

    // Show a specific slide
    const showSlide = ( index ) => {
      $( '#slider-inner .slider-slide' ).hide().eq( index ).fadeIn();
    };

    renderGallery( currentPage, currentFilter );
  }
});